/* eslint-disable prefer-object-spread */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import * as lineInventoryAction from '../../../../../actions/inventoryAction';
import InventoryService from '../../../../../services/InventoryService';
import { ENUMS, VISIONS } from '../../../../../utils/constants';
import { translate, isNullOrEmpty, getUserNameToName } from '../../../../../utils/util';
import { InfiniteScroll } from '../../../../../components/UI/ComponentsUI';
import { getVision } from '../../../../../services/auth';

const ListLotItemGeneral = (props) => {
    const [lotItems, setLotItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const lotOriginId = props.location?.state?.lotOriginId;
    const advanced = props.advancedFilter;
    const secondCount = props.secondCount;
    const refredhAdvancedFilter = props.refredhAdvancedFilter;
    const FilterLot = props.lots?.items?.find((item) => (item.lotNumber === props.filter.lotNumber && item.lotNumber !== 0));
    const linkAcess = lotOriginId === 1 || advanced ? true : !isNullOrEmpty(FilterLot?.startedBy);

    const totalItems = () => {
        if (!props?.lotItems.items) {
            return '';
        }

        let total = 0;
        if (props.lotItems?.totalCount !== lotItems.length || linkAcess) {
            total = props.lotItems?.totalCount;
        } else {
            total = lotItems.filter((i) => i.status !== ENUMS.eInventoryLotItemStatus.Canceled.value).length;
        }

        if (props.advancedFilter) {
            return `${total}`;
        }

        let totalFinished = lotItems.filter((i) => i.status === ENUMS.eInventoryLotItemStatus.Finished.value).length;
        if (getVision() === VISIONS.Jeep) {
            totalFinished = lotItems.filter((m) => m.status === ENUMS.eInventoryLotItemStatus.Finished.value
                || m.divergent).length;
        }

        return `${totalFinished}/${total}`;
    };

    useEffect(() => {
        console.log('linkAcess', linkAcess);
        console.log('secondCount', secondCount);

        refresh();
        // eslint-disable-next-line
    }, [props?.lotItems?.items]);

    const refresh = () => {
        if (props.lotItems?.items?.length > 0) {
            if (lotItems.length > 0 && currentPage === 0) {
                setLotItems(props.lotItems.items);
            } else {
                setLotItems((prevState) => ([...prevState, ...props.lotItems.items]));
            }
        } else {
            setLotItems([]);
        }
    };

    useEffect(() => {
        const filter = Object.assign({}, props.filter);
        filter.lotOriginId = lotOriginId;
        if (lotOriginId === ENUMS.eInventoryOriginCount.Drone.value) {
            filter.lotItemId = undefined;
            filter.divergent = undefined;
        }
        if (advanced) {
            props.getAdvancedLotItems(props.user.vision, filter, {
                PageSize: 20,
                PageIndex: currentPage
            });
        }
        else {
            props.getLotItems(props.user.vision, filter, {
                PageSize: 20,
                PageIndex: currentPage
            });
        }
        // eslint-disable-next-line
    }, [currentPage, refredhAdvancedFilter]);

    const onSelectItemChange = (item) => {
        props.setSelectedLotItem(item);
    };

    const onRenderItem = (data) => {
        return (
            <>
                <span className="title sixth-text-color">
                    <i className="mdi mdi-text-box-check-outline" /> {data.lotItemNumber}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-map-marker-radius-outline" /> {data.location}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-image-filter-center-focus" /> {data.cim}
                </span>
                {
                    !isNullOrEmpty(data.secoundCountBy)
                    &&
                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                        {getUserNameToName(props.usersFromElog, data.secoundCountBy)}
                    </span>
                }
            </>
        );
    };

    const onItemLot = (data) => {
        return (
            (linkAcess && !secondCount) || (secondCount && data.secoundCountBy === props.user.userName) ? (
                <Link
                    style={{ display: 'block' }}
                    to={{
                        pathname: advanced ? '../lotItem' : '../general/lotItem',
                        state: { lotOriginId, secondCount }
                    }}
                    onClick={() => onSelectItemChange(data)}
                >
                    {
                        onRenderItem(data)
                    }
                </Link>
            ) : onRenderItem(data)
        );
    };

    const filterLotItems = () => {
        if (getVision() !== VISIONS.Jeep) {
            return lotItems.filter((f) => f.status !== ENUMS.eInventoryLotItemStatus.Finished.value
                && f.status !== ENUMS.eInventoryLotItemStatus.Canceled.value)
        }

        return lotItems.filter((f) => f.status !== ENUMS.eInventoryLotItemStatus.Finished.value
            && f.status !== ENUMS.eInventoryLotItemStatus.Canceled.value
            && (secondCount || f.readings.length === 0))
    }

    return lotItems ? (
        <div>
            <div className="subtitle">
                {props.advancedFilter ? 'Total' : translate('status', 'inventory')}: {totalItems()}
            </div>
            <div id="listLotItems">
                <InfiniteScroll
                    page={props.lotItems?.totalPages}
                    hasMore={currentPage < props.lotItems?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    data={
                        filterLotItems().map((item) => {
                            return onItemLot(item);
                        })
                    }
                />
            </div>
        </div>
    ) : null;
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        filter: state.inventoryReducer.filter,
        lotItems: state.inventoryReducer.lotItems,
        lots: state.inventoryReducer.lots,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedLotItem: (lotItem) => {
            dispatch(lineInventoryAction.selectLotItem(lotItem));
        },
        getLotItems: (vision, filter, pagination) => {
            dispatch(InventoryService.getLotItems(vision, filter, pagination));
        },
        getAdvancedLotItems: (vision, filter, pagination) => {
            dispatch(InventoryService.getAdvancedLotItems(vision, filter, pagination));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListLotItemGeneral));
